import React, {Component} from "react";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";
import utils from "../../../utils/utils";
import validationHelper from "../../../utils/validationHelper";
import AlertConfirm from "../../../components/modals/Confirm";
import doctorApi from "../../../services/ApiServices/doctorApi";
import {authenticationService} from "../../../services/AuthenticationService";
import {makeError} from "../../../components/modals/ErrorModal";
import {history} from "../../../utils/history";
import RequestMedicalInfoTab from "./RequestTabs/RequestMedicalInfoTab";
import RequestPersonalDetailsTab from "./RequestTabs/RequestPersonalDetailsTab";
import RequestUseOfCannabisTab from "./RequestTabs/RequestUseOfCannabisTab";
import RequestDeclarationTab from "./RequestTabs/RequestDeclarationTab";
import RequestTreatmentTargetsTab from "./RequestTabs/RequestTreatmentTargetsTab";
import RequestVisitSummaryTab from "./RequestTabs/RequestVisitSummaryTab";
import save from "../../../assets/saverPic.png"
import {CannabisPDFDenied} from "./RequestTabs/CannabisPDFDenied";
import {CannabisPDFAccepted} from "./RequestTabs/CannabisPDFAccepted";
import SvGraphics from "../../../assets/SvGraphics";
import PatientEditComment from "../../../components/doctor/PatientEditComment";
import patientApi from "../../../services/ApiServices/patientApi";
import {appendIchilovQuery} from "../../../utils/routeUtils";

class PatientRequestConnected extends Component {
    constructor(props) {
        super(props);
        this.myRef = React.createRef()
        this.state = {
            entry: {
                Phone_num1: "",
                Last_name: "",
                First_name: "",
                Phone_num2: "",
                House_number: "",
                Email: null,
                ID_passport: "",
            },
            view: 1,
            errors: {},
            errorsOnSave: {},
            israelCities: [],
            requestChangesHistory: [],
            patientUploading: true,
            medical_diagnose_icd: [],
            addedProducts: [],
            checkboxes: {},
            productsList: [],
            patientTreatments: [],
            patientOldTreatments: [],
            PatientOldProducts: [],
            PatientOldMedications: [],
            allergics: [],
            patient_allergics: [],
            medicationsList: [],
            fileForms: [],
            otherForms: [],
            general_medications: [],
            bloodThinner_medications: [],
            currentPain_medications: [],
            filesToUpload: [],
            past_med: [],
            titrationPlans: [],
            requestStatuses: [],
            addedFilesList: [],
            isSideBarOpen: false,
            isUploadingFiles: false,
            requestFromVisit: false,

        }
    }

    async componentDidMount() {

        let {t} = this.props
        let {
            general_medications,
            bloodThinner_medications,
            currentPain_medications,
            medical_diagnose_icd,
            fileForms,
            requestStatuses,
            past_med,
            titrationPlans,
            israelCities,
            productsList,
            medicationsList,
            allergics,
            otherForms,
            filesToUpload
        } = this.state

        let allData = await doctorApi.getAllData()
        if (allData) {
            allData = allData.data
            titrationPlans = allData.titrationPlans
            israelCities = allData.cities
            productsList = allData.products
            medicationsList = allData.medications
            allergics = allData.allergics
            otherForms = allData.forms
            medical_diagnose_icd = allData.medical_diagnose_icd
            fileForms = allData.leumitForms
            requestStatuses = allData.statuses
        }

        this.setState({
            productsList, allergics, fileForms, medicationsList, israelCities, otherForms, requestStatuses,
            medical_diagnose_icd, titrationPlans
        })

        let patientInfo = this.props.location.state?.rowInfo


        let info = await doctorApi.getPatientByRequestId(patientInfo.UserStorageID, patientInfo.RequestID)

        info = info ? info.data : []


        let PII = info.PII ? info.PII : {}
        if (PII.Date_of_birth) {
            PII.Date_of_birth = new Date(PII.Date_of_birth)
        }

        let ShowFlag = info.ShowFlag
        let patientRequests = info ? info.Patient_requests : []
        info = patientRequests && patientRequests.length >= 1 ? patientRequests[patientRequests.length - 1] : []

        let hasOldRequest = info.hasOldRequest
        let requestFromVisit = info.IsVisit

        let patientTreatments = info.Patient_treatments ? info.Patient_treatments : []
        let patientOldTreatments = JSON.stringify(patientTreatments)
        this.setState({patientOldTreatments, patientTreatments, requestFromVisit})
        let requestID = info.RequestID

        let Habits_Medicals = ""
        if (info.Habits_Medicals) {
            Habits_Medicals = info.Habits_Medicals.length > 0 ? info.Habits_Medicals[0] : []
        }

        let addedProducts = info.Patient_products ? info.Patient_products : []
        let Patient_type_indication = info.Patient_type_indications ? info.Patient_type_indications[0] : []
        let patient_conditions = info.Patient_conditions ? info.Patient_conditions : ""
        let PatientsPayment = info.PatientsPayment ? info.PatientsPayment : ""

        for (let i = 0; i < addedProducts.length; i++) {
            addedProducts[i]['product_use_obj'] = {
                value: addedProducts[i].product_use,
                label: addedProducts[i].product_use
            }
            addedProducts[i].displayProducts = this.onclickChoosedCategory(addedProducts[i].product_use_category, addedProducts[i].product_type)
        }

        if (PII.Date_of_birth) {
            PII.Date_of_birth = new Date(PII.Date_of_birth)
        }


        let entry = {
            ...PII, ...Habits_Medicals, ...Patient_type_indication, ...info, ...PatientsPayment,
            hasOldRequest: hasOldRequest
        }

        entry['ShowFlag'] = ShowFlag
        entry['RequestID'] = requestID
        entry['paymentDate'] = entry.paymentDate ? utils.getDateFormatWithYear(new Date(entry.paymentDate)) : ""

        let pAllergics = Habits_Medicals['patient_allergics'] ? Habits_Medicals.patient_allergics : ""
        pAllergics = pAllergics ? pAllergics.split(',') : ""

        let patient_allergics = []
        for (let i = 0; i < pAllergics.length; i++) {
            let index = parseInt(pAllergics[i])
            patient_allergics.push({value: index, label: this.getAllergicDesc(index)})
        }
        let addedFilesList = []
        let addedFilesListTemp = []
        addedFilesListTemp = await doctorApi.getAllUploadedFiles(entry.UserStorageID, requestID)
        let language = localStorage.getItem('language')
        addedFilesListTemp = addedFilesListTemp ? addedFilesListTemp.data : []


        for (let i = 0; i < addedFilesListTemp.length; i++) {
            if (addedFilesListTemp[i].Form_type_ID < 21) {
                addedFilesList.push(addedFilesListTemp[i])
            } else {
                let searchIndex = filesToUpload.findIndex(item => item.Form_type_ID === addedFilesListTemp[i].Form_type_ID)
                if (searchIndex >= 0) {
                    filesToUpload[searchIndex].FileUrl.push(addedFilesListTemp[i].Form_url)
                    filesToUpload[searchIndex].File_Name.push(addedFilesListTemp[i].File_Name)
                } else {
                    filesToUpload.push({
                        Form_type_ID: addedFilesListTemp[i].Form_type_ID,
                        Form_desc: language === "he" ? addedFilesListTemp[i].Form_type.Form_desc_he : addedFilesListTemp[i].Form_type.Form_desc,
                        FileUrl: [addedFilesListTemp[i].Form_url],
                        File_Name: [addedFilesListTemp[i].File_Name],
                        isLoading: false
                    })
                }
            }
        }
        let medications = info.Patient_Medications ? info.Patient_Medications : []
        let isOtherPastUseMedication = false

        for (let i = 0; i < medications.length; i++) {
            if (medications[i].General_Thinner_Past === "Past") {
                if (medications[i].Medication_name === "Other") {
                    isOtherPastUseMedication = true
                }
                past_med.push({value: parseInt(medications[i].Med_ID), label: medications[i].Medication_name})
            } else {
                medications[i].MedObj = {value: medications[i].Med_ID, label: medications[i].Medication_name}
                if (medications[i].General_Thinner_Past === "G") {
                    medications[i].index = general_medications.length
                    general_medications.push(medications[i])
                } else if (medications[i].General_Thinner_Past === "T") {
                    medications[i].index = bloodThinner_medications.length
                    bloodThinner_medications.push(medications[i])
                } else if (medications[i].General_Thinner_Past === "CP") {
                    medications[i].index = currentPain_medications.length
                    currentPain_medications.push(medications[i])
                }
            }
        }

        let medICD = {value: "", label: ""}
        for (let i = 0; i < medical_diagnose_icd.length; i++) {
            let medId = medical_diagnose_icd[i].ICD_diagnosis_id ? medical_diagnose_icd[i].ICD_diagnosis_id : ""
            let entry_MedID = entry.medical_diagnoses_icd_name ? entry.medical_diagnoses_icd_name : ""
            if (medId.toString() === entry_MedID.toString()) {
                medICD.label = medical_diagnose_icd[i].Diagnosis_description
                medICD.value = medical_diagnose_icd[i].ICD_diagnosis_id
            }
        }

        entry.medical_diagnoses_icd_name = medICD

        entry.SelectedCity = {value: entry.cityID, label: this.getCityDesc(entry.cityID)}

        patientTreatments = this.handlePatientTreatments(patientTreatments)

        //TODO Fix in the future
        /*if(entry.doctors_referral_name){
            let response = await doctorApi.getRecommendedDoctorName(entry.doctors_referral_name)
            if (response) {
                entry['referralDoc'] = response.data.DoctorName ? response.data.DoctorName : entry.doctors_referral_name
            }
        }*/


        let PatientOldProducts = addedProducts.map(item => {
            return {
                product_use_category: item.product_use_category,
                product_use: item.product_use
            }
        })
        PatientOldProducts = JSON.stringify(PatientOldProducts)
        let PatientOldMedications = JSON.stringify(medications)
        this.setState({
            entry,
            PatientOldProducts,
            PatientOldMedications,
            addedProducts,
            patient_allergics,
            addedFilesList,
            general_medications,
            bloodThinner_medications,
            currentPain_medications,
            past_med,
            filesToUpload,
            patientUploading: false
        })

        if (hasOldRequest === "T") {
            await AlertConfirm({
                options: {
                    headerSvg: 'errorWhite',
                    cancelLabel: 'none',
                    proceedLabel: t('patient_boarding.close'),
                    title: t('patient_boarding.hasOldRequest'),
                }
            }, t('patient_boarding.hasOldRequestInfo'))
        }
    }

    getCityDesc = (val) => {
        let {israelCities} = this.state
        for (let j = 0; j < israelCities.length; j++) {

            if (israelCities[j].index.toString() === val) {
                return israelCities[j].cityName
            }
        }
    }

    setPatientUploading() {
        this.setState({patientUploading: !this.state.patientUploading})
    }

    saveSelectedFile = async (selectedFile, index) => {
        let {entry, filesToUpload} = this.state
        filesToUpload[index]['isLoading'] = true
        this.setState({filesToUpload})
        let requestID = entry.RequestID ? parseInt(entry.RequestID) : 0
        let fileToAdd = {
            selectedCategory: filesToUpload[index].Form_type_ID,
            file: selectedFile,
            UserStorageID: entry.UserStorageID,
            RequestID: requestID
        }

        let response = await doctorApi.getUploadedFile(fileToAdd)
        if (response && response.data) {
            let responseArray = response.data.patientsFormsResult
            responseArray.map(item => {
                filesToUpload[index]['FileUrl'].push(item.Form_url)
                filesToUpload[index]['File_Name'].push(item.File_Name)
            })
        } else {
            await AlertConfirm({
                options: {
                    cancelLabel: "none",
                    title: `Bad File Extension`,
                }
            }, "PDF, PNG,JPEG, TIF,TXT, CSV, DOC")
        }
        filesToUpload[index]['isLoading'] = false

        this.setState({filesToUpload})
    }

    addFileObj = async (index, selectedCategory, selectedFile) => {
        this.setState({isUploadingFiles: true})
        let {addedFilesList, entry} = this.state
        if (selectedFile !== "" && selectedCategory !== "") {
            let fileToAdd = {
                selectedCategory: selectedCategory,
                file: selectedFile,
                UserStorageID: entry.UserStorageID,
                RequestID: entry.RequestID
            }
            let response = await doctorApi.getUploadedFile(fileToAdd)
            if (response && response.data) {
                let responseArray = response.data.patientsFormsResult
                responseArray.map(item => {
                    addedFilesList.push(item)
                })
            } else {
                await AlertConfirm({
                    options: {
                        cancelLabel: "none",
                        title: `Bad File Extension`,
                    }
                }, "PDF, PNG,JPEG, TIF,TXT, CSV, DOC")
            }
        }
        this.setState({addedFilesList, isUploadingFiles: false})
    }

    deleteLeumitUploadedFile = async (index, fileIndex, fileName) => {
        let {t} = this.props
        let {entry, filesToUpload} = this.state
        let confirm = await AlertConfirm({
            proceedLabel: t('patient_self_boarding.continue'),
            cancelLabel: t('patient_self_boarding.cancel'),
            options: {
                title: '',
            }
        }, t('patient_self_boarding.deleteConfirm'))
        if (confirm) {
            let res = await doctorApi.deleteLeumitUploadedFiles(entry.UserStorageID, filesToUpload[index].Form_type_ID, entry.RequestID, fileName)
            if (res) {
                filesToUpload[index].FileUrl.splice(fileIndex, 1)
                filesToUpload[index].File_Name.splice(fileIndex, 1)
            }
            this.setState({filesToUpload})
        }

    }

    deleteUploadedFile = async (index) => {
        this.setState({isUploadingFiles: true})
        let {addedFilesList, entry} = this.state
        let fileToDelete = addedFilesList[index]

        let res = await doctorApi.deleteUploadedFiles(entry.UserStorageID, fileToDelete)
        if (res) {
            if (addedFilesList.length === 1) {
                addedFilesList = []
            } else {
                addedFilesList.splice(index, 1)
            }
        }
        this.setState({addedFilesList, isUploadingFiles: false})
    }

    getAllergicDesc = (index) => {
        let {allergics} = this.state
        let language = localStorage.getItem('language')
        for (let j = 0; j < allergics.length; j++) {
            if (allergics[j].index === index) {
                if (language === "he") {
                    return allergics[j].Allergic_name_he
                } else {
                    return allergics[j].Allergic_name
                }
            }
        }
    }

    onclickChoosedCategory(category, type) {
        let {productsList} = this.state
        let displayProducts = []
        for (let i = 0; i < productsList.length; i++) {
            if ((category === productsList[i].Category && productsList[i].Strain === "Flower")
                || (category === productsList[i].Category && productsList[i].Strain === type)) {
                displayProducts.push(
                    {value: productsList[i].Product_name, label: productsList[i].Product_name})
            }
        }
        return displayProducts
    }

    changeView = (viewNum) => {
        this.setState({view: viewNum})
    }

    initValidation = async (schema) => {
        let {entry} = this.state
        let validationSchema = schema
        let errors = await validationHelper.validate(entry, validationSchema)

        this.setState({
            validationSchema,
            errors
        })
    }

    checkIfFileExists(Form_type_ID) {
        let {filesToUpload} = this.state
        for (let i = 0; i < filesToUpload.length; i++) {
            if (filesToUpload[i].Form_type_ID === Form_type_ID) {
                return true
            }
        }
        return false
    }

    addTransporterForm(value) {
        let {filesToUpload, fileForms} = this.state
        let transporterFormIndex = fileForms.findIndex(item => item.withPrescription === "T")
        if (value) {
            if (!this.checkIfFileExists(fileForms[transporterFormIndex].Form_type_ID)) {
                filesToUpload.push({
                    Form_type_ID: fileForms[transporterFormIndex].Form_type_ID,
                    FormOrder: fileForms[transporterFormIndex].FormOrder,
                    FileUrl: [],
                    File_Name: [],
                    Form_desc: this.getFileFormDesc(transporterFormIndex)
                })
            }
        } else {
            for (let i = 0; i < filesToUpload.length; i++) {
                if (filesToUpload[i].Form_type_ID.toString() === fileForms[transporterFormIndex].Form_type_ID.toString()) {
                    filesToUpload.splice(i, 1)
                }
            }
        }
        if (filesToUpload && filesToUpload.length > 0) {
            filesToUpload.sort((a, b) => a.FormOrder - b.FormOrder);
        }

        this.setState({filesToUpload})
    }

    getFileFormDesc(index) {
        let {fileForms} = this.state
        let language = localStorage.getItem('language')
        let fromLanguage
        if (language === "he") {
            fromLanguage = "Form_desc_he"
        } else {
            fromLanguage = "Form_desc"
        }
        return fileForms[index][fromLanguage]
    }

    onYesNoValueChange(variable, value) {
        let {entry} = this.state
        let isNewRequest = entry.choose_programm === "new" || entry.choose_programm === "newPrescription"
        let isRenew2Request = entry.choose_programm === "renew2" || entry.choose_programm === "renew2Prescription"
        let isRenewRequest = entry.choose_programm === "renew" || entry.choose_programm === "renewPrescription"


        if (variable === "transporter") {
            this.addTransporterForm(!(entry[variable] === value) && value === "Yes")
        } else if (variable === "Psychiatric_diagnosis") {
            this.addPsychiatricForm(
                ((!(entry[variable] === value) && value === "Yes") || entry.Drug_abuse === "Yes" || entry.Nuclear_family_psychosis === "Yes") &&
                (isNewRequest || isRenew2Request))
        } else if (variable === "Nuclear_family_psychosis") {
            this.addPsychiatricForm(
                ((!(entry[variable] === value) && value === "Yes") || entry.Drug_abuse === "Yes" || entry.Psychiatric_diagnosis === "Yes") &&
                (isNewRequest || isRenew2Request))
        } else if (variable === "Drug_abuse") {
            this.addPsychiatricForm(
                ((!(entry[variable] === value) && value === "Yes") || entry.Nuclear_family_psychosis === "Yes" || entry.Psychiatric_diagnosis === "Yes") &&
                (isNewRequest || isRenew2Request))
        }

        if (entry[variable] === value) {
            this.onValueChange(variable, "")
        } else {
            this.onValueChange(variable, value)
        }
    }

    addPsychiatricForm(value) {
        let {filesToUpload, fileForms} = this.state
        let psychiatricFormIndex = fileForms.findIndex(item => item.withPrescription === "P")

        if (value) {
            if (!this.checkIfFileExists(fileForms[psychiatricFormIndex].Form_type_ID)) {
                filesToUpload.push({
                    Form_type_ID: fileForms[psychiatricFormIndex].Form_type_ID,
                    FormOrder: fileForms[psychiatricFormIndex].FormOrder,
                    FileUrl: [],
                    File_Name: [],
                    Form_desc: this.getFileFormDesc(psychiatricFormIndex)
                })
            }
        } else {
            for (let i = 0; i < filesToUpload.length; i++) {
                if (filesToUpload[i].Form_type_ID.toString() === fileForms[psychiatricFormIndex].Form_type_ID.toString()) {
                    filesToUpload.splice(i, 1)
                }
            }
        }
        if (filesToUpload && filesToUpload.length > 0) {
            filesToUpload.sort((a, b) => a.FormOrder - b.FormOrder);
        }

    }

    onClickCheckboxes = async (name) => {
        let {checkboxes} = this.state
        if (checkboxes.hasOwnProperty(name)) {
            checkboxes[name] = !checkboxes[name]
        } else checkboxes[name] = true

        this.onValueChange(name, checkboxes[name])
        this.setState({checkboxes})
    }

    onValueChange = async (name, value) => {
        let {entry, validationSchema, requestChangesHistory} = this.state
        let currentUser = authenticationService.currentUserValue;
        let userID = currentUser.profile.UserStorageID
        if (name !== "selectFileCategory" && name !== "medical_diagnoses_icd_name") {
            let indexOfChange = requestChangesHistory.findIndex(item => item.InputName === name)
            if (indexOfChange >= 0) {
                requestChangesHistory[indexOfChange]['New_Value'] = value
                requestChangesHistory[indexOfChange]['Change_DateTime'] = new Date()
            } else {
                requestChangesHistory.push({
                    Patient_ID: entry.UserStorageID,
                    Doctor_ID: userID,
                    RequestID: entry.RequestID,
                    InputName: name,
                    Old_Value: entry[name],
                    New_Value: value,
                    Change_DateTime: new Date()
                })
            }
        }


        if (name === "Email" && value === "") {
            value = null
        }
        utils.set(entry, name, value)
        // let entryValidator = utils.removeEmptyOrNull(entry)
        let entryValidator = entry

        let errors = await validationHelper.validate(entryValidator, validationSchema);
        let errorsOnSave = this.state.errorsOnSave;

        if (JSON.stringify(errors) === '{}') {
            errorsOnSave = errors
        }

        if (utils.get(errorsOnSave, name)) {
            utils.set(errorsOnSave, name, utils.get(errors, name))
        }

        this.setState({
            entry,
            errors,
            requestChangesHistory,
            errorsOnSave
        })
    }

    onClickAddProducts = async (func, value, index) => {
        let {addedProducts} = this.state
        let tempEntry = {}
        let {t} = this.props
        if (func === "ADD") {
            if (addedProducts.length === 4) {
                let confirm = await AlertConfirm({
                    options: {
                        title: '',
                    }
                }, t('patient_boarding.maxProd'))
            } else {
                tempEntry.index = addedProducts.length
                tempEntry.product_type = "Flower"
                tempEntry.product_use_category = ""
                tempEntry.product_use = ""
                tempEntry.displayProducts = []
                addedProducts.push(tempEntry)
            }
        } else if (func === "product_use_category") {
            addedProducts[index].product_use_category = value
            addedProducts[index].displayProducts = this.onclickChoosedCategory(value, addedProducts[index].product_type)
        } else if (func === "Delete") {
            addedProducts.splice(0, addedProducts.length)
        } else if (func === "product_use_obj") {
            addedProducts[index][func] = value
            addedProducts[index]['product_use'] = value.label

        } else {
            addedProducts[index][func] = value
        }

        this.setState({addedProducts})
    }

    nextButton = () => {
        let {view} = this.state
        this.myRef.current.scrollIntoView()

        let toView = view + 1
        this.changeView(toView)
    }

    backButton = () => {
        let viewNum = this.state.view
        if (viewNum != 1) {
            this.changeView(viewNum - 1)
        }
        // this.props.saveAllPatientData("")
        let elmntToView = document.getElementById('patientTabsMainBox');
        if (elmntToView)
            elmntToView.scrollIntoView();
    }

    saveAllPatientData = async () => {
        let currentUser = authenticationService.currentUserValue;
        let userID = currentUser.profile.UserStorageID

        let {t} = this.props
        let Couldnt_save_patient = t('patient_boarding.Couldnt_save_patient')
        let Couldnt_save_patient_message = t('patient_boarding.Couldnt_save_patient_message')
        let {
            entry, checkboxes, addedProducts, patient_allergics,
            past_med,
            patientTreatments,
            general_medications,
            patientOldTreatments,
            PatientOldProducts,
            PatientOldMedications,
            requestChangesHistory,
            currentPain_medications,
            bloodThinner_medications
        } = this.state

        let errors = await validationHelper.validate(this.state.entry, this.state.validationSchema)

        if (patientTreatments.length > 0) {
            let hasNoMonthlyDosage = false
            for (let i = 0; i < patientTreatments.length; i++) {
                if (!patientTreatments[i].TreatmentMonthlyDosage) {
                    hasNoMonthlyDosage = true
                }
            }
            if (hasNoMonthlyDosage) {
                errors['TreatmentsMandatoryFields'] = 'TreatmentsMandatoryFields'
            } else {
                delete errors['TreatmentsMandatoryFields']
            }
        }


        if (!utils.isEmpty(errors)) {
            this.setState({errorsOnSave: this.state.errors, errors: this.state.errors, loading: false});
            await makeError({
                proceedLabel: t('patient_boarding.ok'),
                options: {
                    title: Couldnt_save_patient,
                }
            }, [Couldnt_save_patient_message]);
            return;
        }

        let allergics = ""
        if (patient_allergics) {
            for (let i = 0; i < patient_allergics.length; i++) {
                allergics = i === 0 ? patient_allergics[i].value : allergics + "," + patient_allergics[i].value
            }
        }
        entry = {...entry, ...checkboxes}
        entry.patient_allergics = allergics

        let medications = []

        medications = medications.concat(general_medications, currentPain_medications, bloodThinner_medications)

        for (let i = 0; i < past_med.length; i++) {
            let a = {Med_ID: past_med[i].value, Medication_name: past_med[i].label, General_Thinner_Past: "Past"}
            medications.push(a)
        }

        entry['LastVisitDate'] = (new Date())
        entry['medications'] = medications

        entry['Patient_products'] = addedProducts
        entry['Patient_treatments'] = patientTreatments


        let patientNewProducts = addedProducts.map(item => {
            return {
                product_use_category: item.product_use_category,
                product_use: item.product_use
            }
        })

        let patientNewTreatments = JSON.stringify(patientTreatments)
        patientNewProducts = JSON.stringify(patientNewProducts)
        let patientNewMed = JSON.stringify(medications)

        if (patientNewTreatments !== patientOldTreatments) {
            requestChangesHistory.push({
                Patient_ID: entry.UserStorageID,
                Doctor_ID: userID,
                RequestID: entry.RequestID,
                InputName: "patientTreatments",
                Old_Value: patientOldTreatments,
                New_Value: patientNewTreatments,
                Change_DateTime: new Date()
            })
        }
        if (patientNewProducts !== PatientOldProducts) {
            requestChangesHistory.push({
                Patient_ID: entry.UserStorageID,
                Doctor_ID: userID,
                RequestID: entry.RequestID,
                InputName: "Patient_products",
                Old_Value: PatientOldProducts,
                New_Value: patientNewProducts,
                Change_DateTime: new Date()
            })
        }
        if (patientNewMed !== PatientOldMedications) {
            requestChangesHistory.push({
                Patient_ID: entry.UserStorageID,
                Doctor_ID: userID,
                RequestID: entry.RequestID,
                InputName: "Patient_medications",
                Old_Value: PatientOldMedications,
                New_Value: JSON.stringify(medications),
                Change_DateTime: new Date()
            })
        }


        if (entry.Phone_num1 && !entry.Phone_num1.includes('972')) {
            entry.Phone_num1 = "972" + entry.Phone_num1.substring(1)
            this.onValueChange("Phone_num1", entry.Phone_num1)
        }
        entry['requestChangesHistory'] = requestChangesHistory

        let medLabel = entry.medical_diagnoses_icd_name?.label ? entry.medical_diagnoses_icd_name.label : ""
        if (medLabel === "OTHER") {
            entry.medical_diagnoses_icd_name = 351
        } else {
            let medDiagnosis = entry.medical_diagnoses_icd_name ? entry.medical_diagnoses_icd_name.value : ""
            entry.medical_diagnoses_icd_name = medDiagnosis
        }

        entry['DeclarationAccept'] = entry.DeclarationAccept === 1 || entry.DeclarationAccept === "1" || entry.DeclarationAccept === true

        let response = await doctorApi.PatientVisit(entry, entry.UserStorageID)
        if (response && response.data && response.data.status === 400) {
            let confirm = await AlertConfirm({
                options: {
                    cancelLabel: "none",
                    title: t('patient_boarding.mediator'),
                }
            }, t('patient_boarding.mediatorExistError'))
            return;
        } else if (response) {
            this.setState({requestChangesHistory: []})
            history.push(appendIchilovQuery('/pain_requests_dashboard'))

        } else {
            await makeError({
                proceedLabel: t('patient_boarding.ok'),
                options: {
                    title: Couldnt_save_patient,
                }
            }, [Couldnt_save_patient]);
            return;
        }
    }

    handlePatientTreatments(patientTreatments) {
        for (let i = 0; i < patientTreatments.length; i++) {
            let arr = []
            let symptomsID = patientTreatments[i].Symptom_ID ? patientTreatments[i].Symptom_ID : ""

            let choosenSymptoms = Array.isArray(symptomsID) ? symptomsID : symptomsID.split("/")
            choosenSymptoms.map(item => arr.push(parseInt(item)))
            patientTreatments[i].Symptom_ID = arr
            if (patientTreatments[i].Titration_code === "New") {
                this.getNewTitrationPlan(i)
            } else {
                this.getTitrationPlan(patientTreatments[i].Titration_code, i)
            }
        }
        return patientTreatments
    }

    onClickPatientAllergics(event) {
        this.setState({patient_allergics: event})
    }

    onClickAddDeleteMedications = (index, event, id, type) => {
        let {
            currentPain_medications,
            bloodThinner_medications,
            general_medications,
            past_med,
            isOtherPastUseMedication
        } = this.state
        let medications = []
        if (type === "CP") {
            medications = currentPain_medications
        } else if (type === "GEN") {
            medications = general_medications
        } else if (type === "BT") {
            medications = bloodThinner_medications
        }
        if (id === "Med_ID") {
            medications[event]['Med_ID'] = index.value
            medications[event]['Medication_name'] = index.label
            medications[event]['MedObj'] = index
        } else if (id === "past_med") {
            let indexOther = index.find((obj => obj.label === "Other"));
            this.onValueChange("PastUseOtherMed", " ")
            isOtherPastUseMedication = indexOther ? true : false
            this.setState({past_med: index, isOtherPastUseMedication})
        } else {
            medications[index][id] = event
        }
        if (type === "CP") {
            this.setState({currentPain_medications: medications, isOtherPastUseMedication})
        } else if (type === "GEN") {
            this.setState({general_medications: medications, isOtherPastUseMedication})
        } else if (type === "BT") {
            this.setState({bloodThinner_medications: medications, isOtherPastUseMedication})
        }
    }

    addDeleteMedication(func, index) {
        let {currentPain_medications, general_medications, bloodThinner_medications} = this.state
        if (func === "addGen") {
            general_medications.push({index: index, General_Thinner_Past: "G"})
        } else if (func === "addThinner") {
            bloodThinner_medications.push({index: index, General_Thinner_Past: "T"})
        } else if (func === "addCP") {
            currentPain_medications.push({index: index, General_Thinner_Past: "CP"})
        } else if (func === "deleteCP") {
            currentPain_medications.splice(index, 1)
        } else if (func === "deleteThinner") {
            bloodThinner_medications.splice(index, 1)
        } else if (func === "deleteGen") {
            general_medications.splice(index, 1)
        }
        this.setState({general_medications, bloodThinner_medications, currentPain_medications})
    }

    getPatientAge(birthday) {
        if (birthday !== null) {
            let todayDate = new Date().toISOString()
            let todayExactDate = (todayDate.split('T'))[0].split('-')
            let currentYear = todayExactDate[0]
            let currentMonth = todayExactDate[1]
            let birthDate = birthday ? birthday.toISOString() : ""
            let exactDate = (birthDate.split('T'))[0].split('-')
            let yearDiff = currentYear - exactDate[0]
            let monthDiff = currentMonth - exactDate[1]
            if (monthDiff < 0) {
                return (yearDiff - 1) + "." + (12 + monthDiff)
            } else {
                return yearDiff + "." + (monthDiff)
            }
        }
        return ""

    }

    getSymptomsDesc = (Symptom_ID, lang) => {
        let {symptomsList} = this.state
        let language = lang ? lang : localStorage.getItem('language')
        symptomsList = symptomsList ? symptomsList : []
        for (let j = 0; j < symptomsList.length; j++) {
            if (symptomsList[j].Symptom_ID.toString() === Symptom_ID) {
                if (language === "he") {
                    return symptomsList[j].Symptom_description_he
                } else {
                    return symptomsList[j].Symptom_description
                }
            }
        }
    }

    getNewTitrationPlan(index) {
        let {patientTreatments} = this.state
        let indexPlan = 0
        let plan = []

        for (let i = parseInt(patientTreatments[index].TreatmentInitialDose); i <= parseInt(patientTreatments[index].Treatment_Maximum_dosage); i++) {
            let currentDose = parseInt(patientTreatments[index].TreatmentInitialDose) + indexPlan
            plan.push({M: currentDose.toString(), E: currentDose.toString(), N: currentDose.toString()})
            indexPlan += 1
        }
        patientTreatments[index]['titrationPlan'] = plan

        this.setState({patientTreatments})

    }

    getTitrationPlan = async (value, index) => {

        let {titrationPlan, titrationPlans} = this.state

        if (value === "New") {
            this.editTreatmentPlan("Titration_code", value, index)
            this.editTreatmentPlan("TreatmentInitialDose", "", index)
            this.editTreatmentPlan("Treatment_Maximum_dosage", "", index)
            this.editTreatmentPlan("titrationPlan", "", index)
            this.editTreatmentPlan("TreatmentStepUpEvery", "", index)

        } else {
            for (let i = 0; i < titrationPlans.length; i++) {

                if (titrationPlans[i].Titration_code === value) {
                    titrationPlan = titrationPlans[i].Titration_steps
                    this.editTreatmentPlan("Titration_code", value, index)
                    this.editTreatmentPlan("titrationPlan", titrationPlan, index)
                    this.editTreatmentPlan("TreatmentInitialDose", titrationPlans[i].Initial_dose, index)
                    this.editTreatmentPlan("Treatment_Maximum_dosage", titrationPlans[i].Maximum_daily_dose, index)
                    this.editTreatmentPlan("TreatmentStepUpEvery", 3, index)
                }
            }
        }
    }

    async DeleteTreatment(index) {
        let {patientTreatments} = this.state
        let {t} = this.props

        let title = t('patient_boarding.delete_treatment')
        let message = t('patient_boarding.delete_treatment_message')
        let confirm = await AlertConfirm({
            options: {
                title: title,
            }
        }, message)
        if (confirm) {
            patientTreatments.splice(index, 1)
            this.setState({patientTreatments})
        }

    }

    async addTreatmentPlan() {
        let {t} = this.props
        let {patientTreatments, choosenTargetsSymptoms} = this.state
        let targetsSymptoms = {isExpanded: true}
        targetsSymptoms.index = patientTreatments.length
        patientTreatments.map(item => item.isExpanded = false)
        if (patientTreatments.length < 4) {
            patientTreatments.push(targetsSymptoms)
        } else {
            await makeError({
                proceedLabel: t('patient_boarding.ok'),
            }, [t('patient_boarding.maxTreatments')]);
            return;
        }
        this.setState({patientTreatments})
    }

    editTreatmentPlan = async (func, value, index) => {
        let {patientTreatments} = this.state
        let currentIndex = index
        patientTreatments.map((item, index) => {
            if (index !== currentIndex) {
                patientTreatments[index]["isExpanded"] = false
            } else {
                patientTreatments[index]["isExpanded"] = true
            }
        })
        if (func === "Symptom_ID") {
            if (patientTreatments[index].Symptom_ID) {
                let choosenTargetsSymptoms = patientTreatments[index].Symptom_ID
                let found = 0
                let indexArr = 0
                for (let i = 0; i < choosenTargetsSymptoms.length; i++) {
                    if (choosenTargetsSymptoms[i] === value) {
                        found = +1
                        indexArr = i
                    }
                }
                if (found > 0) {
                    choosenTargetsSymptoms.splice(indexArr, 1);
                } else {
                    choosenTargetsSymptoms.push(value)
                }
                patientTreatments[index].Symptom_ID = choosenTargetsSymptoms
            } else {
                patientTreatments[index].Symptom_ID = [value]
            }
        } else if (func === "TreatmentMonthlyDosage" && value !== "Other") {
            patientTreatments[index][func] = value
            patientTreatments[index]["TreatmentMonthlyDosageOther"] = 0
        } else {
            patientTreatments[index][func] = value

            if (patientTreatments[index].Titration_code === "New") {
                this.getNewTitrationPlan(index)
            }

        }
        this.setState({patientTreatments})
    }

    backToRequests = async () => {
        this.props.history.replace(appendIchilovQuery('/pain_requests_dashboard'));
    }

    goToPatientPage = async () => {
        let {entry} = this.state
        let rowInfo = {UserStorageID: entry.UserStorageID, RequestID: entry.RequestID, isFromRequest: true}
        this.props.history.push({
            pathname: `/dashboard/Patient`,
            state: {
                rowInfo,
                from: {
                    fromPath: `/pain_patientRequest`,
                }
            },
        })
    }

    async handleCompleteRequest(value) {
        let {entry} = this.state
        this.setState({patientUploading: true})
        this.onClickCheckboxes(value)
        if (entry.requestStatus.toString() === "6" || entry.requestStatus.toString() === "5") {
            await this.sendFile(entry.requestStatus.toString())
        }
        this.setState({patientUploading: false})

    }

    async sendFile(value) {
        let {entry, patientTreatments} = this.state
        value = value.toString()
        entry['patientTreatments'] = patientTreatments
        let requestSummary = value === "6" ? new CannabisPDFDenied(entry) : new CannabisPDFAccepted(entry)
        let html = requestSummary.initHTML()
        html = html.replaceAll("\"", '\'')

        let fileName = value === "6" ? "CNN_BRILMEDICAL" : "CNP_BRILMEDICAL"
        fileName = fileName ? fileName + "_" + entry.ID_passport : fileName
        let currentDate = (new Date().toISOString()).split('T')
        let fileDate = currentDate ? currentDate[0] : []
        let fileTime = currentDate ? currentDate[1] : ""
        fileTime = fileTime ? fileTime.substring(0, 5) : ""

        fileName = fileName ? fileName + "_" + fileDate.split('-').join('') : fileName
        fileName = fileName ? fileName + "_" + fileTime.split(':').join('') : fileName

        let obj = {
            "html": html,
            "inline": true,
            "fileName": fileName,
            "options": {
                "displayHeaderFooter": true,
                "orientation": "Portrait",
                "pageSize": "A4",
                "footerTemplate": "<div class=\"page-footer\" style=\"width:100%; font-size:8px; color: #1d1d1b;font-family: Assistant, sans-serif; font-weight: 300;text-align:center;\"> <span class=\"pageNumber\"></span>/<span class=\"totalPages\"></span></div>"
            },
            "enableToc": false,
            "tocOptions": {
                "tocHeaderText": "Lorem Ipsum",
                "tocLevelIndentation": "1em"
            },
            "useCustomStorage": false,
            "storage": {
                "method": "PUT",
                "url": "https://presignedurl",
                "extraHTTPHeaders": {}
            }
        }
        let response = await doctorApi.generatePDFAPI(obj)

        let doc
        if (response) {
            doc = response.data.FileUrl
            this.onValueChange("responseFile", doc)
            this.onValueChange("responseFileName", fileName)
        }
    }

    openSideBar() {
        this.setState({isSideBarOpen: true})
        document.body.style.overflow = "hidden"
    }

    render() {
        let {view, entry, requestStatuses, isSideBarOpen} = this.state
        let {t} = this.props
        let language = localStorage.getItem('language')
        let PatientName = entry.First_name + ' ' + entry.Last_name
        let id = entry.ID_passport ? entry.ID_passport : ""

        let age = this.getPatientAge(entry.Date_of_birth)

        if (this.state.patientUploading) {
            return <div className="loader"/>
        }
        let requestOptions = []
        for (let i = 0; i < requestStatuses.length; i++) {
            if (language === "he") {
                requestOptions.push(<option className={"requestStatus_menu"}
                                            value={requestStatuses[i].status_ID}>{requestStatuses[i].status_desc_he}</option>)
            } else {
                requestOptions.push(<option className={"requestStatus_menu"}
                                            value={requestStatuses[i].status_ID}>{requestStatuses[i].status_desc}</option>)
            }
        }


        let programm = entry.choose_programm
        programm = programm === "new" ? t('patient_self_boarding.new_license') : programm
        programm = programm === "renew" ? t('patient_self_boarding.renew_license') : programm
        programm = programm === "renew2" ? t('patient_self_boarding.renew2_license') : programm
        programm = programm === "change" ? t('patient_self_boarding.change_dose') : programm
        programm = programm === "newPrescription" ? t('patient_self_boarding.new_Prescription') : programm
        programm = programm === "renewPrescription" ? t('patient_self_boarding.renew_Prescription') : programm
        programm = programm === "renew2Prescription" ? t('patient_self_boarding.renew2_Prescription') : programm

        let selectProgramm = [
            <option className={"requestStatus_menu"}
                    value={"new"}>{t('patient_self_boarding.new_license')}</option>,
            <option className={"requestStatus_menu"}
                    value={"renew"}>{t('patient_self_boarding.renew_license')}</option>,
            <option className={"requestStatus_menu"}
                    value={"renew2"}>{t('patient_self_boarding.renew2_license')}</option>,
        ]

        if (entry.Insuring_factor === "3") {
            selectProgramm = [
                <option className={"requestStatus_menu"}
                        value={"new"}>{t('patient_self_boarding.new_license')}</option>,
                <option className={"requestStatus_menu"}
                        value={"renew"}>{t('patient_self_boarding.renew_license')}</option>,
                <option className={"requestStatus_menu"}
                        value={"renew2"}>{t('patient_self_boarding.renew2_license')}</option>,
                <option className={"requestStatus_menu"}
                        value={"newPrescription"}>{t('patient_self_boarding.new_Prescription')}</option>,
                <option className={"requestStatus_menu"}
                        value={"renewPrescription"}>{t('patient_self_boarding.renew_Prescription')}</option>,
                <option className={"requestStatus_menu"}
                        value={"renew2Prescription"}>{t('patient_self_boarding.renew2_Prescription')}</option>
            ]
        }


        let mediatorCode = entry.MediatorCode
        return (

            <div ref={this.myRef}>
                <div className={'asaya-info-selfOnboarding'}>
                    <div style={{display: 'flex'}}>
                        <div className={'adminMargin-title-Leumit'}>
                            <div style={{display: 'flex'}}>
                                <SvGraphics svgname={'arrow-right-white'} className="arrow-title"
                                            onClick={() => this.backToRequests()}/>
                                <div className="NewLeumitPatientTitle2" style={{cursor: 'pointer'}}
                                     onClick={() => this.goToPatientPage()}>{PatientName}</div>

                                <div className="NewLeumitPatientBlock">
                                    {entry.ShowFlag &&
                                        <SvGraphics svgname={'flag'} style={{width: '20px', height: '20px'}}/>}
                                </div>
                                {entry.hasOldRequest === "T" && <div style={{marginTop: '15px'}}>
                                    <SvGraphics svgname={'errorRed'} className="plazma-error"/>
                                    <label
                                        className="hasOldRequestTitle">{t('patient_boarding.hasOldRequestInfo')}</label>
                                </div>}
                            </div>
                            <div style={{display: 'flex'}}>
                                <div style={{display: 'flex', width: '100%'}}>
                                    <div className="NewLeumitPatientBlock">
                                        <label
                                            className="NewLeumitPatientTitle">{t('patient_boarding.id_number')}</label>
                                        <label className="NewLeumitPatientTitleValue">{id}</label>
                                    </div>
                                    <div className={"title_splash"}/>
                                    <div className="NewLeumitPatientBlock">
                                        <label className="NewLeumitPatientTitle">{t('patient_boarding.age')}</label>
                                        <label className="NewLeumitPatientTitleValue">{age}</label>
                                    </div>
                                    <div className={"title_splash"}/>
                                    <div className="NewLeumitPatientBlock">
                                        <label
                                            className="NewLeumitPatientTitle">{t('hcpLeumitPatientRequests.requestType')}</label>
                                        {/*<label className="NewLeumitPatientTitleValue">{programm}</label>*/}
                                        <select className={'selectBox-menu-up-Leumit2'} id="selectFileCategory"
                                                name="selectFileCategory"
                                                value={entry.choose_programm}
                                                onChange={(event) => this.onValueChange("choose_programm", event.target.value)}>
                                            {selectProgramm}
                                        </select>
                                    </div>
                                    <div className={"title_splash"}/>
                                    <div className="NewLeumitPatientBlock">
                                        <input type={"checkbox"} className={"checkboxStyle-header"}
                                               name={'renewCurrentDose'}
                                               checked={entry.renewCurrentDose === "Yes"}/>
                                        <label
                                            className="NewLeumitPatientTitleValue">{t('patient_boarding.renewCurrentDose')}</label>
                                    </div>

                                    <div className={"title_splash"}/>
                                    <div className="NewLeumitPatientBlock">
                                        <label
                                            className="NewLeumitPatientTitle">{t('patient_boarding.mediator')}</label>
                                        <label className="NewLeumitPatientTitleValue">{mediatorCode}</label>
                                    </div>
                                    <div className={"title_splash"}/>
                                    <div className={'leumitPatientHeaderStatus'}>
                                        <label
                                            className="NewLeumitPatientTitle">{t('hcpLeumitPatientRequests.status')}</label>
                                        <select className={'selectBox-menu-up-Leumit'} id="selectFileCategory"
                                                name="selectFileCategory"
                                                value={entry.requestStatus}
                                                onChange={(event) => this.onValueChange("requestStatus", event.target.value)}>
                                            {requestOptions}
                                        </select>
                                    </div>
                                    <div className={"title_splash"}/>
                                    <div className="NewLeumitPatientBlock">
                                        <input type={"checkbox"} className={"checkboxStyle-header"} name={'isCompleted'}
                                               checked={entry.isCompleted}
                                               onChange={event => this.handleCompleteRequest(event.target.name)}/>
                                        <label
                                            className="NewLeumitPatientTitleValue">{t('patient_boarding.isCompleted')}</label>
                                    </div>
                                    <div className={"title_splash"}/>
                                    <div className="NewLeumitPatientBlock">
                                        <input type={"checkbox"} className={"checkboxStyle-header"} name={'isPaid'}
                                               checked={entry.Success === "1"}/>
                                        <label
                                            className="NewLeumitPatientTitleValue">{t('patient_boarding.isPaid')}</label>
                                        <label className="NewLeumitPatientTitleValue">{entry.paymentDate}</label>
                                    </div>
                                    {entry.ZohoId && <>
                                        <div className={"title_splash"}/>
                                        <div className="NewLeumitPatientBlock">

                                            <a href={`https://crm.zoho.eu/crm/org20103260603/tab/CustomModule4/${entry.ZohoId}`}
                                               target="_blank"
                                               className="NewLeumitPatientTitleValue"> מעבר לזוהו
                                            </a>

                                        </div>
                                    </>
                                    }

                                </div>
                            </div>
                        </div>
                        <div>
                            <div className={'save-data-button'} onClick={() => this.saveAllPatientData()}>
                                <SvGraphics svgname={'saveIcon'}
                                            style={{width: '14px', height: '14px', marginTop: '8px'}}/>
                                <div className={'save-data-button-text'}>{t('admin.hcp.form.save')} </div>
                            </div>
                            <div className={'save-data-button'} onClick={() => this.openSideBar()}>
                                <SvGraphics svgname={'editComment'}
                                            style={{width: '14px', height: '14px', marginTop: '8px'}}/>
                                <div
                                    className={'save-data-button-text'}>{t('defaults.Registration.edit_comment')} </div>
                            </div>
                        </div>


                    </div>

                </div>

                <div className={'Patient-Screen'}>

                    <div className={'adminMargin-patientOnboard'}>

                        <div className={'self-onboard-patientTabsMainBox'} id={'patientTabsMainBox'}>
                            <div tabIndex={0} className={view === 1 ? 'patientTabsCurrBox' : 'patientTabsBoxes'}
                                 onClick={() => this.changeView(1)}>
                                <label
                                    className={view === 1 ? 'patientTabsCurrBox-label' : 'patientTabsBoxes-label'}>{t('patient_boarding.personal_details')}</label>
                            </div>
                            <div tabIndex={0} className={view === 2 ? 'patientTabsCurrBox' : 'patientTabsBoxes'}
                                 onClick={() => this.changeView(2)}>
                                <label
                                    className={view === 2 ? 'patientTabsCurrBox-label' : 'patientTabsBoxes-label'}>{t('patient_boarding.Medical_information')}</label>
                            </div>
                            <div tabIndex={0} className={view === 3 ? 'patientTabsCurrBox' : 'patientTabsBoxes'}
                                 onClick={() => this.changeView(3)}>
                                <label
                                    className={view === 3 ? 'patientTabsCurrBox-label' : 'patientTabsBoxes-label'}>{t('patient_boarding.cannabis_patient')}</label>
                            </div>
                            <div tabIndex={0} className={view === 4 ? 'patientTabsCurrBox' : 'patientTabsBoxes'}
                                 onClick={() => this.changeView(4)}>
                                <label
                                    className={view === 4 ? 'patientTabsCurrBox-label' : 'patientTabsBoxes-label'}>{t('patient_boarding.declarations')}</label>
                            </div>
                            <div tabIndex={0} className={view === 5 ? 'patientTabsCurrBox' : 'patientTabsBoxes'}
                                 onClick={() => this.changeView(5)}>
                                <label
                                    className={view === 5 ? 'patientTabsCurrBox-label' : 'patientTabsBoxes-label'}>{t('patient_boarding.request_summary')}</label>
                            </div>
                            <div tabIndex={0} className={view === 6 ? 'patientTabsCurrBox' : 'patientTabsBoxes'}
                                 onClick={() => this.changeView(6)}>
                                <label
                                    className={view === 6 ? 'patientTabsCurrBox-label' : 'patientTabsBoxes-label'}>{t('patient_boarding.treatment_plan')}</label>
                            </div>

                            <div/>
                            <div/>

                        </div>
                        {
                            view === 1 ? (
                                    <RequestPersonalDetailsTab
                                        onValueChange={(name, value) => this.onValueChange(name, value)}
                                        initValidation={(schema) => this.initValidation(schema)}
                                        onYesNoValueChange={(name, value) => this.onYesNoValueChange(name, value)}
                                        requestFromVisit={this.state.requestFromVisit}
                                        entry={this.state.entry}
                                        errors={this.state.errors}
                                        israelCities={this.state.israelCities}
                                        cityList={this.state.cityList}
                                        t={e => this.props.t(e)}
                                    />)
                                : view === 2 ? (
                                    <RequestMedicalInfoTab
                                        requestFromVisit={this.state.requestFromVisit}
                                        onValueChange={(name, value) => this.onValueChange(name, value)}
                                        filesToUpload={this.state.filesToUpload}
                                        entry={this.state.entry}
                                        fileForms={this.state.fileForms}
                                        addFileObj={(index, selectedCategory, selectedFile) => this.addFileObj(index, selectedCategory, selectedFile)}
                                        saveSelectedFile={(selectedFile, index) => this.saveSelectedFile(selectedFile, index)}
                                        deleteLeumitUploadedFile={(index, fileIndex, fileName) => this.deleteLeumitUploadedFile(index, fileIndex, fileName)}
                                        deleteUploadedFile={(index) => this.deleteUploadedFile(index)}
                                        otherForms={this.state.otherForms}
                                        addedFilesList={this.state.addedFilesList}
                                        allergics={this.state.allergics}
                                        patient_allergics={this.state.patient_allergics}
                                        onClickPatientAllergics={(value) => this.onClickPatientAllergics(value)}
                                        onClickMedicationConditions={(value) => this.onClickMedicationConditions(value)}
                                        initValidation={(schema) => this.initValidation(schema)}
                                        onYesNoValueChange={(name, value) => this.onYesNoValueChange(name, value)}
                                        errors={this.state.errors}
                                        isUploadingFiles={this.state.isUploadingFiles}
                                        general_medications={this.state.general_medications}
                                        bloodThinner_medications={this.state.bloodThinner_medications}
                                        currentPain_medications={this.state.currentPain_medications}
                                        past_med={this.state.past_med}
                                        medicationsList={this.state.medicationsList}
                                        onClickAddDeleteMedications={(index, event, id, type) => this.onClickAddDeleteMedications(index, event, id, type)}
                                        addDeleteMedication={(func, index) => this.addDeleteMedication(func, index)}
                                        t={e => this.props.t(e)}
                                    />) : view === 3 ? (
                                    <RequestUseOfCannabisTab
                                        onValueChange={(name, value) => this.onValueChange(name, value)}
                                        onClickCheckboxes={(name) => this.onClickCheckboxes(name)}
                                        initValidation={(schema) => this.initValidation(schema)}
                                        onYesNoValueChange={(name, value) => this.onYesNoValueChange(name, value)}
                                        entry={this.state.entry}
                                        addedProducts={this.state.addedProducts}
                                        checkboxes={this.state.checkboxes}
                                        errors={this.state.errors}
                                        productsList={this.state.productsList}
                                        t={e => this.props.t(e)}
                                        onClickAddProducts={(func, value, index) => this.onClickAddProducts(func, value, index)}

                                    />) : view === 4 ? (
                                    <RequestDeclarationTab
                                        onValueChange={(name, value) => this.onValueChange(name, value)}
                                        onClickCheckboxes={(name) => this.onClickCheckboxes(name)}
                                        initValidation={(schema) => this.initValidation(schema)}
                                        checkboxes={this.state.checkboxes}
                                        entry={this.state.entry}
                                        errors={this.state.errors}
                                        t={e => this.props.t(e)}
                                    />) : view === 5 ? (
                                    <RequestVisitSummaryTab
                                        checkboxes={this.state.checkboxes}
                                        entry={this.state.entry}
                                        requestStatuses={this.state.requestStatuses}
                                        medical_diagnose_icd={this.state.medical_diagnose_icd}
                                        errors={this.state.errors}
                                        patientTreatments={this.state.patientTreatments}
                                        onClickCheckboxes={(name) => this.onClickCheckboxes(name)}
                                        onClickMedicationConditions={(value) => this.onClickMedicationConditions(value)}
                                        initValidation={(schema) => this.initValidation(schema)}
                                        getConditionDesc={(index) => this.getConditionDesc(index)}
                                        setPatientUploading={() => this.setPatientUploading()}
                                        onValueChange={(name, value) => this.onValueChange(name, value)}
                                        t={e => this.props.t(e)}
                                    />
                                ) : view === 6 ? (
                                    <RequestTreatmentTargetsTab
                                        onValueChange={(name, value) => this.onValueChange(name, value)}
                                        entry={this.state.entry}
                                        errors={this.state.errors}
                                        titrationPlans={this.state.titrationPlans}
                                        symptomsList={this.state.symptomsList}
                                        choosenTargetsSymptoms={this.state.choosenTargetsSymptoms}
                                        patientTreatments={this.state.patientTreatments}
                                        symptoms={this.state.symptoms}
                                        getSymptomsDesc={(Symptom_ID, lang) => this.getSymptomsDesc(Symptom_ID, lang)}
                                        t={e => this.state.t(e)}
                                        titrationPlan={this.state.titrationPlan}
                                        getNewTitration={(initialDose, maxDosage, stepEach) => this.getNewTitration(initialDose, maxDosage, stepEach)}
                                        getTitrationPlan={(val, index) => this.getTitrationPlan(val, index)}
                                        DeleteTreatment={(index) => this.DeleteTreatment(index)}
                                        addTreatmentPlan={() => this.addTreatmentPlan()}
                                        editTreatmentPlan={(func, value, index) => this.editTreatmentPlan(func, value, index)}
                                        productsList={this.state.productsList}
                                    />
                                ) : <div>

                                </div>
                        }
                        <div className={'backBox'}>
                            <div className={'backBoxRighting'} onClick={this.backButton.bind(this)}
                                 style={{display: view !== 1 ? 'block' : 'none'}}>
                                {t('patient_boarding.back')}
                            </div>


                            <div className={view !== 1 ? 'selfNextButton2' : 'selfNextButton'}
                                 onClick={() => this.nextButton()} style={{display: view !== 6 ? 'block' : 'none'}}>
                                {t('patient_boarding.next')}
                            </div>

                        </div>
                    </div>
                </div>

                {isSideBarOpen && <PatientEditComment
                    t={e => t(e)}
                    title={t('hcpLeumitPatientRequests.Comment')}
                    entry={this.state.entry}
                    onValueChange={(name, value) => this.onValueChange(name, value)}
                    isSideBarOpen={isSideBarOpen}
                    closeSideBar={() => this.setState({isSideBarOpen: false})}/>}

            </div>
        )
    }

}

const PatientRequest = compose(
    withTranslation(),
    connect(
        /* mapStateToProps,
        mapDispatchToProps*/
    )
)(PatientRequestConnected)

export default PatientRequest;
